import TileLayer from 'ol/layer/Tile';
import { XYZ, Vector as VectorSource, TileWMS } from 'ol/source';
import { Vector as VectorLayer } from 'ol/layer';
import GeoJSON from 'ol/format/GeoJSON';
import { Style, Fill, Stroke } from 'ol/style';
import { abstractFetch } from '../../common/func/abstractFetch';
import { imagePostFunction } from '../../common/func/imagePost';
import { poiStyle } from '../../common/data/poiStyle';

const bgLayers = {
	bgLayer: new TileLayer({
		visible: true,
		source: new XYZ({
			title: '브이월드 일반',
			url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgGrayLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 백지도',
			url: 'https://xdworld.vworld.kr/2d/white/service/{z}/{x}/{y}.png',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
	bgSatelliteLayer: new TileLayer({
		visible: false,
		source: new XYZ({
			title: '브이월드 위성',
			url: 'https://xdworld.vworld.kr/2d/Satellite/service/{z}/{x}/{y}.jpeg',
			attributions: '공간정보오픈플랫폼',
		}),
	}),
};

const poiLayers = {
	admCenter: new VectorLayer({
		title: '행정복지센터',
		visible: false,
		opacity: 1,
		zIndex: 2,
		renderMode: 'vector',
		source: new VectorSource({ format: new GeoJSON() }),
		style: poiStyle.admCenter,
	}),
	university: new VectorLayer({
		title: '대학교',
		visible: false,
		opacity: 1,
		zIndex: 2,
		renderMode: 'vector',
		source: new VectorSource({ format: new GeoJSON() }),
		style: poiStyle.university,
	}),
	industry: new VectorLayer({
		title: '산업단지',
		visible: false,
		opacity: 1,
		zIndex: 2,
		renderMode: 'vector',
		source: new VectorSource({ format: new GeoJSON() }),
		style: poiStyle.industry,
	}),
	hospital: new VectorLayer({
		title: '병·의원',
		visible: false,
		opacity: 1,
		zIndex: 2,
		renderMode: 'vector',
		source: new VectorSource({ format: new GeoJSON() }),
		style: poiStyle.hospital,
	}),
	security: new VectorLayer({
		title: '경찰서',
		visible: false,
		opacity: 1,
		zIndex: 2,
		renderMode: 'vector',
		source: new VectorSource({ format: new GeoJSON() }),
		style: poiStyle.security,
	}),
	industryPolygon: new TileLayer({
		title: '산업단지 폴리곤',
		visible: false,
		source: new TileWMS({
			url: process.env.REACT_APP_GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				LAYERS: 'pinogio:sph_polygon',
			},
			serverType: 'geoserver',
			// crossOrigin: 'anonymous',
			tileLoadFunction: function (image, src) {
				imagePostFunction(image, src);
			},
		}),
	}),
};

const householdLayers = {
	sphGridLayer: new TileLayer({
		title: '1인가구 격자',
		visible: true,
		source: new TileWMS({
			url: process.env.REACT_APP_GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				LAYERS: 'pinogio:sph_grid_all_pop',
				STYLES: 'sph_grid_all_pop',
			},
			serverType: 'geoserver',
			// crossOrigin: 'anonymous',
			tileLoadFunction: function (image, src) {
				imagePostFunction(image, src);
			},
		}),
	}),
	sphPopGridLayer: new TileLayer({
		title: '1인 가구 수 밀도 격자',
		visible: false,
		source: new TileWMS({
			url: process.env.REACT_APP_GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				LAYERS: 'pinogio:sph_grid_all_pop',
				STYLES: 'sph_pop_grid',
			},
			serverType: 'geoserver',
			// crossOrigin: 'anonymous',
			tileLoadFunction: function (image, src) {
				imagePostFunction(image, src);
			},
		}),
	}),
	sphAggGridLayer: new TileLayer({
		title: '1인가구 집적지 격자',
		visible: true,
		source: new TileWMS({
			url: process.env.REACT_APP_GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				LAYERS: 'pinogio:sph_grid_agg',
				STYLES: 'sph_grid_agg',
			},
			serverType: 'geoserver',
			// crossOrigin: 'anonymous',
			tileLoadFunction: function (image, src) {
				imagePostFunction(image, src);
			},
		}),
	}),
	zoomLayer: new VectorLayer({
		title: '지도 줌 레이어',
		visible: false,
		renderMode: 'vector',
		source: new VectorSource({ format: new GeoJSON() }),
	}),
	sphAgglomerateLayer: new VectorLayer({
		title: '집적지 분석 격자',
		visible: false,
		renderMode: 'vector',
		source: new VectorSource({ format: new GeoJSON() }),
		style: new Style({
			fill: new Fill({ color: '#228FA1' }),
			stroke: new Stroke({ color: '#fff', width: 1 }),
		}),
	}),
	sphLocationLayer: new VectorLayer({
		title: '입지분석 격자',
		visible: false,
		renderMode: 'vector',
		source: new VectorSource({ format: new GeoJSON() }),
		style: new Style({
			fill: new Fill({ color: '#C00000' }),
			stroke: new Stroke({ color: '#fff', width: 1 }),
		}),
	}),
	sphIdsLayer: new VectorLayer({
		title: '중첩 격자',
		visible: false,
		renderMode: 'vector',
		source: new VectorSource({ format: new GeoJSON() }),
		style: new Style({
			fill: new Fill({ color: '#C00000' }),
			stroke: new Stroke({ color: 'rgba(98, 255, 97)', width: 3 }),
		}),
	}),
	bgEmdLayer: new TileLayer({
		title: '읍면동 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: process.env.REACT_APP_GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				STYLES: 'sph_sido_boundary_black',
				LAYERS: 'pinogio:bnd_dong_sim_202112',
			},
		}),
		visible: false,
	}),
	bgSggLayer: new TileLayer({
		title: '시군구 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: process.env.REACT_APP_GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				STYLES: 'sph_sido_boundary_black',
				LAYERS: 'pinogio:bnd_sigungu_sim_202206',
			},
		}),
		visible: true,
	}),
	bgSidoLayer: new TileLayer({
		title: '시도 경계',
		opacity: 0.8,
		source: new TileWMS({
			url: process.env.REACT_APP_GISSERVER_URL,
			params: {
				VERSION: '1.3.0',
				FORMAT: 'image/png',
				TRANSPARENT: 'true',
				tiled: 'false',
				STYLES: 'sph_sido_boundary_black',
				LAYERS: 'pinogio:bnd_sido_sim_202112',
			},
		}),
		visible: true,
	}),
};

const getZoomExtent = async (xmlString, map) => {
	const vectorRequest = {
		service: 'WFS',
		version: '1.0.0',
		request: 'GetFeature',
		outputFormat: 'application/json',
		srsName: 'EPSG:3857',
		typeName: 'pinogio:sph_grid_all_pop',
		filter: xmlString,
	};
	abstractFetch(vectorRequest).then((res) => {
		const features = new GeoJSON().readFeatures(res);
		householdLayers.zoomLayer.getSource().clear();
		householdLayers.zoomLayer.getSource().addFeatures(features);
		map.getView().fit(householdLayers.zoomLayer.getSource().getExtent(), map.getSize());
		map.getView().setZoom(map.getView().getZoom() - 1);
	});
};

const getAgglomerateFeatures = (xmlString) => {
	const vectorRequest = {
		service: 'WFS',
		version: '1.0.0',
		request: 'GetFeature',
		outputFormat: 'application/json',
		srsName: 'EPSG:3857',
		typeName: 'pinogio:sph_grid_all_pop',
		filter: xmlString,
	};
	abstractFetch(vectorRequest).then((res) => {
		const features = new GeoJSON().readFeatures(res);
		householdLayers.sphAgglomerateLayer.getSource().clear();
		householdLayers.sphAgglomerateLayer.getSource().addFeatures(features);
	});
};

const getLocationFeatures = async (viewParams) => {
	const vectorRequest = {
		service: 'WFS',
		version: '1.0.0',
		request: 'GetFeature',
		outputFormat: 'application/json',
		srsName: 'EPSG:3857',
		typeName: 'pinogio:sph_grid_sql_view',
		viewParams: viewParams,
	};

	await abstractFetch(vectorRequest).then((res) => {
		const features = new GeoJSON().readFeatures(res);
		householdLayers.sphLocationLayer.getSource().clear();
		householdLayers.sphLocationLayer.getSource().addFeatures(features);
	});
};

const getIdsFeatures = async (viewParams) => {
	const vectorRequest = {
		service: 'WFS',
		version: '1.0.0',
		request: 'GetFeature',
		outputFormat: 'application/json',
		srsName: 'EPSG:3857',
		typeName: 'pinogio:sph_overlap_grid',
		viewParams: viewParams,
	};
	await abstractFetch(vectorRequest).then((res) => {
		const features = new GeoJSON().readFeatures(res);
		householdLayers.sphIdsLayer.getSource().clear();
		householdLayers.sphIdsLayer.getSource().addFeatures(features);
	});
};

const poiMatch = {
	1: {
		type: 1,
		poiType: 'university',
		layer: poiLayers.university,
	},
	2: {
		type: 2,
		poiType: 'industry',
		layer: poiLayers.industry,
	},
	3: {
		type: 3,
		poiType: 'security',
		layer: poiLayers.security,
	},
	4: {
		type: 4,
		poiType: 'admCenter',
		layer: poiLayers.admCenter,
	},
	5: {
		type: 5,
		poiType: 'hospital',
		layer: poiLayers.hospital,
	},
};

const getPoiFeatures = async (xmlString, type) => {
	const vectorRequest = {
		service: 'WFS',
		version: '1.0.0',
		request: 'GetFeature',
		outputFormat: 'application/json',
		srsName: 'EPSG:3857',
		typeName: 'pinogio:sph_poi',
		filter: xmlString,
	};
	let features;
	await abstractFetch(vectorRequest).then((res) => {
		features = new GeoJSON().readFeatures(res);
		poiMatch[type].layer.getSource().clear();
		poiMatch[type].layer.getSource().addFeatures(features);
	});
	return features;
};

const bgMapObject = {
	basic: 'bgLayer',
	white: 'bgGrayLayer',
	satellite: 'bgSatelliteLayer',
};

export {
	bgLayers,
	poiLayers,
	householdLayers,
	getZoomExtent,
	getAgglomerateFeatures,
	getLocationFeatures,
	getIdsFeatures,
	getPoiFeatures,
	bgMapObject,
};
